import { useEffect } from 'react';
import type { Topic } from '@cyphex/types';
import { getRealtime } from '@/features/chat/api';

/**
 * Subscribe while a surface is mounted; unsubscribe when it is not.
 *
 * Subscriptions are the client's half of the fanout budget — a tab that stays
 * subscribed to every channel it ever opened makes the gateway deliver events
 * nobody is looking at. Keying the effect on the joined topic string (not the
 * array identity) means a re-render never churns a subscription.
 */
export function useTopicSubscription(topics: readonly (Topic | null | undefined)[]): void {
  const wanted = topics.filter((topic): topic is Topic => typeof topic === 'string' && topic !== '');
  const key = wanted.join('|');

  useEffect(() => {
    if (key === '') return undefined;
    const list = key.split('|');
    const realtime = getRealtime();
    realtime.connect();
    realtime.subscribe(list);
    return () => realtime.unsubscribe(list);
  }, [key]);
}
